import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import "./login.css";
import {
  authentication,
  verifyEmail,
  verifyEmailAddress,
} from "./../../../actions/auth-actions";
import LoginService from "./../../../services/auth-service";
import { useDispatch } from "react-redux";
import LoaderOverlay from "./../../common/helper/loader.component.js";
import { toast } from "react-toastify";
import {
  initialFormData,
  initialErrors,
  fieldValidation,
} from "../../common/helper/form-constants.js";
import { authConstants } from "./../../../constants/auth-constants.js";
import { MESSAGES } from "../../constants/constants.js";
import useIsMobile from "../../common/hooks/useIsMobile.js";

const ForgotPassword = () => {
  const [formData, setFormData] = useState({ email: "" });
  const [errors, setErrors] = useState({ ...initialErrors });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const isMobile=useIsMobile();
  const validateField = (fieldName, value) => {
    const errorMessage = fieldValidation(fieldName, value);
    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage }));
    return errorMessage;
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    validateField(name, value);
  };

  const forgotPass = (e) => {
    e.preventDefault();
    let hasErrors;
    Object.keys(formData).forEach((fieldName) => {
      const error = validateField(fieldName, formData[fieldName]);
      if (error) {
        hasErrors = true;
      }
    });
    if (!hasErrors) {
      dispatch(verifyEmail(formData))
        .then((response) => {
          dispatch(verifyEmailAddress(formData));
          toast.success(response.data.message);
          navigate("/reset-password");
        })
        .catch((error) => {
          try {
            const errorMessage = error.response.data;
            toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR);
          } catch (e) {
            toast.error(MESSAGES.SERVER_ERROR);
          }
        });
    }
  };

  const login = () => {
    navigate("/");
  };
  useEffect(() => {
    document.body.style.backgroundImage = "url('assets/download.jpeg')";
    document.body.style.backgroundSize = "cover";

      document.getElementsByClassName("forgot-pssd")[0].style.backgroundImage="url('assets/img6.avif')";
      document.getElementsByClassName("forgot-pssd")[0].style.backgroundSize = "cover";
   

      return () => {
        document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
      };
    }, []);

  return (
    <>
      <LoaderOverlay loading={loading} />
      <div className="container-fluid vh-100 m-0 " style={{padding:isMobile?"0px" :"90px 150px", }}>
        <div className="row h-100 m-0 p-0" style={{borderRadius:isMobile? "20px":"40px", overflow:"hidden"}}>
          {/* Left side - Image (70%) */}
          <div className="col-lg-7 d-none d-lg-block p-0 position-relative">
            <img
              src="assets/img9.avif"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                opacity: "0.8",
              }}
            ></img>
            <div
              className="position-absolute bottom-0 start-0 p-5 text-white"
              style={{
                background:
                  "linear-gradient(to top, rgba(0,0,0,0.7), transparent)",
              }}
            >
              <h2
                className="display-5 fw-bold mb-3 text-white"
                style={{ color: "white" }}
              >
                 {process.env.REACT_APP_TITLE}
              </h2>
              <p className="fs-5 text-white" style={{ color: "white" }}>
                Giving you more autonomy to control your money.
              </p>
              <div style={{ border: "1px solid white", width: "120px" }}></div>
            </div>
          </div>
          <div className="forgot-pssd col-12 col-lg-5 d-flex align-items-center justify-content-center bg-white">
            <div className="container">
              <div className="row align-items-center justify-content-center">
                <div className="col-md-12">
                  <div className="px-4">
                    <div className="text-center mb-4">
                      <a href="#">
                        <img
                          style={{ width: "200px" }}
                          src={process.env.REACT_APP_LOGO_URL}
                        />
                      </a>
                      <h6
                        style={{ marginTop: "15px" }}
                        className="text-uppercase"
                      >
                        Forgot Password
                      </h6>
                    </div>
                    <form
                      method="post"
                      id="forgot_form"
                      name="login_form"
                      noValidate="novalidate"
                      onSubmit={forgotPass}
                    >
                      <div className="form-group first mb-5">
                        <label className="required" htmlFor="username">
                          Email
                        </label>
                        <input
                          type="email"
                          name="email"
                          className={`form-control ${
                            errors.email ? "is-invalid" : ""
                          }`}
                          onChange={handleChange}
                          placeholder="Enter your registered email"
                          minLength={4}
                          id="email"
                          required
                        />
                        {errors.email && (
                          <div className="invalid-feedback">{errors.email}</div>
                        )}
                      </div>
                      <button
                        type="submit"
                        style={{ fontSize: "15px" }}
                        className="btn btn-block py-2 btn-bg-theme-Color"
                      >
                        Forgot Password
                      </button>
                      <div className="mt-3 align-items-center text-center">
                        <span
                          className="ml-auto"
                          style={{
                            fontSize: "13.5px!important",
                            fontWeight: 600,
                          }}
                        >
                          <a
                            style={{ cursor: "pointer" }}
                            onClick={login}
                            className="forgot-pass"
                          >
                            Back To Login
                          </a>
                        </span>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ForgotPassword;
